export const INCHES_PER_FOOT = 12;

export const fromInchesToFt = (inches: number): number => {
    return inches / INCHES_PER_FOOT;
};

export const fromFtToInches = (ft: number): number => {
    return ft * INCHES_PER_FOOT;
};
